export const BULK_CHANGE_PERMISSION_QUERY = `
query GetBulkEditPermission ($cloudId: ID!) {
    jira {
      permission(cloudId: $cloudId, type: BULK_CHANGE)
        @optIn(to: "JiraPermission")
        {
            hasPermission
        }
    }
  }
`;
